import React from 'react'
import { useState, useEffect } from 'react'
import { Drawer, Form, Row, Col ,Button, Space, Typography } from "antd"
import { MyInput, } from '../../Forms';
import { apiCalls } from '../../../shared/Apis';

const {Title} = Typography;
const Addfaq = ({visible, onClose, edititem, getFaqApi}) => {
    const [form] = Form.useForm()
    const [ loading, setLoading ] = useState(false)  
    
    useEffect(() => {
        if (visible && edititem) {
            form.setFieldsValue({
                ...edititem,
                title: edititem?.title,
                description: edititem?.description
            });
        } else {
            form.resetFields();
        }
    }, [visible, edititem]);

    const updateCreateApi = async (formData) => {
        setLoading(true);
        try {
            const result = await apiCalls.addFaqsApi.updateCreateApi({...formData,id:edititem?.id});
            setLoading(false);
            getFaqApi();
            if (result) {
                form.resetFields();
                onClose();
            }
        } catch (error) {
            console.error('Error updating/creating faqs:', error);
            setLoading(false);
        }
    };
    

    const onFinish = async () => {
        try {
            const formData = await form.validateFields();
            updateCreateApi(formData);
        } catch (error) {
            console.error("Form validation error:", error);
        }
    };

    

    const closeDrawer= ()=>{
        form.resetFields()
        onClose()
    }


  return (
    <Drawer
        title={edititem?'Edit Faq':'Add Faq'}
        onClose={closeDrawer}
        className="drawer"
        open={visible}
        width={500}
        footer={
        <Space className="w-100 right">
            <Button 
                onClick={closeDrawer}
                className="btncancel"
            >
                Cancel
            </Button>
            <Button  
                block
                className='btnsave bg-brand'
                type="primary"
                htmlType="submit"
                loading={loading}
                onClick={()=> form.submit()}
            >
                {edititem? 'Update' : 'Save'}
            </Button>
        </Space>
    }
>
    <Form
        form={form}
        layout="vertical"
        initialValues={true}
        onFinish={onFinish}
    >
        <Row gutter={16} justify={'center'}>
            <Col span={24}>
                <Title level={5} className="mb-3 mt-0">FAQ DETAILS</Title>
            </Col>
            <Col lg={{span: 24}} md={{span: 24}} xs={{span: 24}} sm={{span: 24}}>
                <MyInput
                    label= 'Faq Title'
                    name="title" 
                    size={'large'}
                    message='Please enter faq title'
                />
            </Col>
            <Col lg={{span: 24}} md={{span: 24}} xs={{span: 24}} sm={{span: 24}}>
                <MyInput
                    label= 'Faq Description'
                    name="description" 
                    size={'large'}
                    textArea
                    message='Please enter faq description'
                    rows={6}
                />
            </Col>
        </Row>
    </Form>
</Drawer>
  )
}

export {Addfaq}